import { FileTypesCompliance } from '@/constants/FileTypesCompliance';
import { FileTypesMarketing } from '@/constants/FileTypesMarketing';
import {
  ComplianceDocument,
  MarketingAssetSchema,
} from '@/lib/types';

const Component = ({
  file,
}: {
  file: MarketingAssetSchema | ComplianceDocument;
}) => {
  const isCompliance = 'document_type' in file;
  const isMarketing = 'file_type' in file;

  const complianceType = isCompliance
    ? (file as ComplianceDocument).document_type?.toLowerCase()
    : undefined;

  const marketingType = isMarketing
    ? (file as MarketingAssetSchema).file_type?.toLowerCase()
    : undefined;

  return (
    <>
      {complianceType &&
        (FileTypesCompliance?.[complianceType]?.label
          ? FileTypesCompliance?.[complianceType]?.label
          : complianceType)}
      {marketingType &&
        (FileTypesMarketing?.[
          marketingType as keyof typeof FileTypesMarketing
        ]?.label
          ? FileTypesMarketing?.[
              marketingType as keyof typeof FileTypesMarketing
            ]?.label
          : marketingType)}
    </>
  );
};

export default Component;
